import React from 'react';
import swal from 'sweetalert';

import useGlobalState from '../GlobalStateContext';
import { handleResponseError } from '../helpers/ResponseErrorHelper';
import axios from '../services/MyAxios';

import { OptionalRolesOrPermissions } from 'crm/helpers/Permissions';

type Props = {
    url: string;
    params: any;
    action: Function;
} & OptionalRolesOrPermissions;

export default function DetachElement({ url, params, action, roles = [], permissions = [] }: Readonly<Props>) {
    const { loggedAdmin } = useGlobalState();

    function handleDeleteClick() {
        swal({
            title: 'Detach resource',
            text: 'Are you sure you want to detach resource?',
            icon: 'warning',
            buttons: true as any,
            dangerMode: true,
        }).then((willDetach) => {
            if (willDetach) {
                const requestUrl = `${url}/detach`;
                axios
                    .post(requestUrl, params)
                    .then(() => action())
                    .catch(handleResponseError);
            }
        });
    }

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <span className="btn btn-primary btn-sm square-button" onClick={handleDeleteClick}>
            <i className="fa fa-trash-alt" />
        </span>
    ) : null;
}
